import { TYPE_LABELS } from './changeLabels';
import type { ConditionalChoice } from './changeFormConditionalOptions';

const stripDiacritics = (value: string) =>
  value.normalize('NFD').replace(/\p{M}/gu, '').toLowerCase();

/** Normaliza código ou rótulo de tipo de mudança para o `code` canônico (ex.: normal, emergencial). */
export function normalizeChangeTypeCode(
  raw: string,
  typeOptions: ConditionalChoice[] = [],
): string {
  const trimmed = String(raw || '').trim();
  if (!trimmed) return '';

  for (const option of typeOptions) {
    if (option.value === trimmed) return option.value;
    if (option.label.trim() === trimmed) return option.value;
    if (stripDiacritics(option.label) === stripDiacritics(trimmed)) return option.value;
  }

  const lower = trimmed.toLowerCase();
  for (const [code, label] of Object.entries(TYPE_LABELS)) {
    if (code.toLowerCase() === lower) return code;
    if (label.toLowerCase() === trimmed.toLowerCase()) return code;
    if (stripDiacritics(label) === stripDiacritics(trimmed)) return code;
  }

  return lower.replace(/\s+/g, '_');
}
